<template>
  <div class="w-100">
    <div class="row">
      <div class="col-12">
        <z-form ref="form" class="z-card border-0" @submit.native.prevent="save">
          <div class="row">
            <div class="col-6">
              <base-form v-model="base_form" />
            </div>
          </div>

          <div class="row mt-4">
            <div class="col-6">
              <internal-number-form v-model="internal_form" :numbers="number_int" />
            </div>
          </div>

          <div class="row mt-4">
            <div class="col-6">
              <external-number-form v-model="external_form" :numbers="number_ext" />
            </div>
          </div>
        </z-form>
      </div>
    </div>

    <div class="row mt-4">
      <div class="col-12">
        <i-button type="primary" size="large" @click="save">
          {{ $t('shared.component.button.save') }}
        </i-button>
      </div>
    </div>
  </div>
</template>

<script>
  import BaseForm from './base-form';
  import InternalNumberForm from './internal-number-form';
  import ExternalNumberForm from './external-number-form';
  import { SipAccountService } from '@pbx/services/SipAccountService';
  import { PageServerValidationResponseMixin } from '@shared/mixins/page-server-validation-response';
  import { NumberService } from '@pbx/services/NumberService';

  export default {
    components: { BaseForm, InternalNumberForm, ExternalNumberForm },
    mixins: [PageServerValidationResponseMixin],
    data() {
      return {
        base_form: {},
        internal_form: {},
        external_form: {},
        number_ext: {},
        number_int: {}
      };
    },

    created() {
      const is_external = number_item => number_item.type === 'external';
      const is_internal = number_item => number_item.type === 'internal' && !number_item.used;

      NumberService.getSelect().then(res => {
        this.number_ext = res.filter(number => is_external(number));
        this.number_int = res.filter(number => is_internal(number));
      });
    },

    methods: {
      save: function() {
        this.$refs.form.validate().then(is_valid => {
          if (is_valid) {
            SipAccountService.createItem({
              ...this.base_form,
              ...this.internal_form,
              ...this.external_form
            })
              .then(() => this.$router.push({ name: 'pbx.sip-account.index' }))
              .catch(e => this.check_server_validation(e));
          }
        });
      }
    }
  };
</script>
